@import '@fontsource-variable/geist';
@import '@fontsource-variable/geist-mono';

@tailwind base;
@tailwind components;
@tailwind utilities;

/* Strats tokens (docs/12-ux.md §1): warm neutral ground, lavender accent (up/long), orange (down/short). */
:root {
  --bg: 248 247 244; --side: 242 240 235; --card: 255 255 255; --soft: 240 238 233;
  --line: 231 229 224; --line-strong: 226 223 216;
  --ink: 47 49 59; --ink-strong: 35 37 45; --muted: 111 113 124; --faint: 140 141 151;
  --accent: 90 107 196; --accent-soft: 236 238 250; --accent-ink: 54 69 154;
  --teal: 47 127 119; --dark: 35 51 46; --on-dark: 248 247 244;
  --warn: 180 85 45; --warn-soft: 251 234 223; --warn-ink: 138 63 28;
  --ok: 47 127 95; --ok-soft: 231 241 238; --ok-ink: 35 87 77; --danger: 200 69 43;
  color-scheme: light;
}
@media (prefers-color-scheme: dark) {
  :root {
    --bg: 24 24 23; --side: 30 30 28; --card: 36 36 34; --soft: 44 44 41;
    --line: 52 52 49; --line-strong: 64 64 60;
    --ink: 232 232 228; --ink-strong: 246 246 242; --muted: 160 160 152; --faint: 130 130 124;
    --accent: 140 158 240; --accent-soft: 44 48 72; --accent-ink: 176 188 250;
    --teal: 52 140 130; --dark: 228 236 232; --on-dark: 24 24 23;
    --warn: 230 140 100; --warn-soft: 66 44 34; --warn-ink: 240 170 135;
    --ok: 110 190 160; --ok-soft: 32 56 48; --ok-ink: 150 210 185; --danger: 236 110 90;
    color-scheme: dark;
  }
}

html, body, #root { min-height: 100%; }
body { @apply bg-bg text-ink antialiased; margin: 0; font-family: 'Geist Variable', 'Geist', -apple-system, 'Segoe UI', sans-serif; font-size: 14px; }
button { cursor: pointer; font: inherit; }
button:disabled { cursor: default; opacity: .6; }
a { @apply text-accent-ink; text-decoration: none; }
a:hover { text-decoration: underline; }
.num { font-family: 'Geist Mono Variable', 'Geist Mono', ui-monospace, monospace; font-variant-numeric: tabular-nums; }
.eyebrow { @apply text-[12px] font-semibold uppercase tracking-[0.12em] text-muted; }
.h1 { @apply m-0 text-[32px] font-bold leading-tight tracking-[-0.03em] text-ink-strong md:text-[40px]; }
.h2 { @apply m-0 text-[20px] font-semibold tracking-[-0.01em] text-ink-strong; }
.card { @apply rounded-card border border-line bg-card; }
.tile { @apply rounded-[10px] bg-soft px-3 py-2.5; }
.btn { @apply inline-flex items-center justify-center gap-1.5 rounded-lg border border-line-strong bg-card px-3.5 py-2 text-[14px] font-medium text-ink; }
.btn:hover:not(:disabled) { @apply bg-soft; }
.btn-primary { @apply inline-flex items-center justify-center gap-1.5 rounded-lg border-0 bg-dark px-3.5 py-2 text-[14px] font-medium text-on-dark; }
.btn-primary:hover:not(:disabled) { opacity: .92; }
.btn-warn { @apply inline-flex items-center justify-center gap-1.5 rounded-lg border border-warn/40 bg-warn-soft px-3.5 py-2 text-[14px] font-medium text-warn-ink; }
/* labels are plain text: no pills or status chips anywhere (owner preference) */
.chip { @apply text-[13px] text-muted; }
.input { @apply w-full rounded-lg border border-line-strong bg-card px-3 py-2 text-[14px] text-ink outline-none; }
.input:focus { @apply border-accent; box-shadow: 0 0 0 3px rgb(var(--accent) / .15); }
.table { @apply w-full border-collapse text-[14px]; }
.table th { @apply border-b border-line px-3 py-2 text-left text-[12px] font-medium text-muted; }
.table td { @apply border-b border-soft px-3 py-2.5; }
.up { @apply text-accent-ink; }
.down { @apply text-warn-ink; }
:focus-visible { outline: 2px solid rgb(var(--accent)); outline-offset: 2px; }
@media (prefers-reduced-motion: reduce) { * { animation: none !important; transition: none !important; } }
